import { IClassname } from '@/lib/shared/model/classname';

export const Guard = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8052 28.9704V21.124"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.722 7.24609C14.3002 7.79615 14.0712 8.46978 14.0703 9.16297C14.0703 10.0103 14.4069 10.8229 15.006 11.422C15.6052 12.0212 16.4178 12.3578 17.2651 12.3578C18.1124 12.3578 18.925 12.0212 19.5242 11.422C20.1233 10.8229 20.4599 10.0103 20.4599 9.16297C20.4664 8.47273 20.2464 7.7994 19.8337 7.24609H14.722Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8338 7.24586H14.0832L12.652 3.9105C12.6082 3.80365 12.5942 3.68693 12.6114 3.57275C12.6287 3.45857 12.6766 3.3512 12.75 3.26206C12.8234 3.17293 12.9196 3.10535 13.0283 3.06651C13.1371 3.02768 13.2543 3.01904 13.3676 3.04152L20.3067 4.49834C20.4013 4.5193 20.4899 4.56151 20.5658 4.62178C20.6418 4.68205 20.703 4.7588 20.7448 4.84622C20.7867 4.93364 20.8081 5.02944 20.8075 5.12636C20.8068 5.22329 20.7842 5.3188 20.7412 5.40566L19.8338 7.24586Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0832 7.24609L11.5273 8.52401"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8051 21.111L9.26528 25.5837C8.974 25.9965 8.53243 26.2786 8.03543 26.3694C7.53843 26.4602 7.02565 26.3524 6.60722 26.0693C6.39832 25.9272 6.2198 25.7449 6.08205 25.5331C5.9443 25.3213 5.85008 25.0842 5.80488 24.8356C5.75969 24.587 5.76441 24.3319 5.81879 24.0852C5.87317 23.8385 5.97611 23.605 6.12161 23.3985L11.8722 15.731C12.0491 15.4782 12.2843 15.2719 12.558 15.1295C12.8316 14.9871 13.1356 14.9129 13.4441 14.9131H14.952C15.063 14.9162 15.1715 14.9471 15.2674 15.0029C15.3634 15.0587 15.4439 15.1376 15.5015 15.2326L17.2778 18.1079L19.003 15.2326C19.0606 15.1376 19.1411 15.0587 19.2371 15.0029C19.3331 14.9471 19.4415 14.9162 19.5525 14.9131H20.4726C21.4894 14.9131 22.4645 15.317 23.1835 16.036C23.9025 16.7549 24.3064 17.7301 24.3064 18.7468V25.7754C24.3064 26.2838 24.1044 26.7713 23.7449 27.1308C23.3854 27.4903 22.8979 27.6923 22.3895 27.6923C21.8811 27.6923 21.3935 27.4903 21.0341 27.1308C20.6746 26.7713 20.4726 26.2838 20.4726 25.7754V19.3858"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.696 28.9707H1.30396"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
